import { formatCheck, formatDateDDMMYYYY } from '@components/common/format';
import { TableNoLazy } from '@components/form';
import { CREATE_TRACK_MOD_LOG, SELECT_SAFRA_FAZENDA } from '@handler';
import { MODULE_FUNCTIONALITY_ENUM } from '@handler/tracking/moduleLog/moduleFunctionalityEnum';
import { MODULES_ENUM } from '@handler/tracking/moduleLog/modulesEnum';
import { trackEvent } from 'mixpanel';
import { Column } from 'primereact/column';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader } from 'reactstrap';
import './SafraMenu.css';

class SafraMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            modalSafraOpen: false,
            isMobile: window.innerWidth <= 990
        };
        this.toggle = this.toggle.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.checkAndAnimateHeaders = this.checkAndAnimateHeaders.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    handleResize() {
        this.setState({ isMobile: window.innerWidth <= 990 });
    }

    checkAndAnimateHeaders() {
        const safraContainers = document.querySelectorAll('.safra-container');
        const fazendaContainers = document.querySelectorAll('.fazenda-container');

        safraContainers.forEach((safraContainer, index) => {
            const fazendaContainer = fazendaContainers[index];

            if (!safraContainer) return;

            const safraText = safraContainer.querySelector('.safra-text');
            const fazendaText = fazendaContainer ? fazendaContainer.querySelector('.fazenda-text') : null;

            if (!safraText) return;

            safraText.removeAttribute('data-text');
            safraText.style.removeProperty('--scroll-distance');
            safraText.style.removeProperty('--animation-duration');
            safraText.style.removeProperty('--padding-right');

            if (fazendaText) {
                fazendaText.removeAttribute('data-text');
                fazendaText.style.removeProperty('--scroll-distance');
                fazendaText.style.removeProperty('--animation-duration');
                fazendaText.style.removeProperty('--padding-right');
            }

            const safraOverflows = safraText.scrollWidth > safraContainer.clientWidth;
            const fazendaOverflows = fazendaText && fazendaText.scrollWidth > fazendaContainer.clientWidth;

            if (safraOverflows && fazendaOverflows) {
                const safraDistance = safraText.scrollWidth;
                const fazendaDistance = fazendaText.scrollWidth;

                const maxDistance = Math.max(safraDistance, fazendaDistance);
                const baseDuration = 10;
                const paddingBetween = 30;

                safraText.setAttribute('data-text', safraText.textContent);
                fazendaText.setAttribute('data-text', fazendaText.textContent);

                safraText.style.setProperty('--scroll-distance', `${maxDistance}px`);
                fazendaText.style.setProperty('--scroll-distance', `${maxDistance}px`);

                const safraPadding = maxDistance - safraDistance + paddingBetween;
                const fazendaPadding = maxDistance - fazendaDistance + paddingBetween;

                safraText.style.setProperty('--padding-right', `${safraPadding}px`);
                fazendaText.style.setProperty('--padding-right', `${fazendaPadding}px`);

                safraText.style.setProperty('--animation-duration', `${baseDuration}s`);
                fazendaText.style.setProperty('--animation-duration', `${baseDuration}s`);

                safraText.classList.add('animate-scroll');
                fazendaText.classList.add('animate-scroll');
            } else if (fazendaOverflows && !safraOverflows) {
                const fazendaDistance = fazendaText.scrollWidth;

                fazendaText.setAttribute('data-text', fazendaText.textContent);

                fazendaText.style.setProperty('--scroll-distance', `${fazendaDistance}px`);
                fazendaText.style.setProperty('--padding-right', '30px');
                fazendaText.style.setProperty('--animation-duration', '10s');
                fazendaText.classList.add('animate-scroll');
            } else if (safraOverflows && !fazendaOverflows) {
                const safraDistance = safraText.scrollWidth;

                safraText.setAttribute('data-text', safraText.textContent);

                safraText.style.setProperty('--scroll-distance', `${safraDistance}px`);
                safraText.style.setProperty('--padding-right', '30px');
                safraText.style.setProperty('--animation-duration', '10s');
                safraText.classList.add('animate-scroll');
            }
        });
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('resize', this.checkAndAnimateHeaders);
        setTimeout(() => this.checkAndAnimateHeaders(), 100);
        if (this.props.startSessionReducer.configSession !== null && this.props.startSessionReducer.configSession !== undefined
            && this.props.startSessionReducer.configSession.safras !== null && this.props.startSessionReducer.configSession.safras !== undefined
            && this.props.startSessionReducer.configSession.safras.length > 1 && this.props.startSessionReducer.configSession.safraAtiva === null) {
            this.setState({
                modalSafraOpen: true
            })
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('resize', this.checkAndAnimateHeaders);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.startSessionReducer.configSession !== this.props.startSessionReducer.configSession) {
            setTimeout(() => this.checkAndAnimateHeaders(), 100);
        }
    }

    renderColumnName = (rowData) => {
        if (this.state.isMobile) {
            return (
                <span>
                    {rowData.nome}<br />
                    <div style={{ fontSize: '12px', fontStyle: 'italic' }}>
                        {`${formatDateDDMMYYYY(rowData.dataInicial)} - ${formatDateDDMMYYYY(rowData.dataFinal)}`}
                    </div>
                </span>
            );
        }
        return rowData.nome;
    }

    renderColumnAtivo = (value) => formatCheck(value.status);

    renderColumnDataInicial = (value) => formatDateDDMMYYYY(value.dataInicial);

    renderColumnDataFinal = (value) => formatDateDDMMYYYY(value.dataFinal);

    render() {
        const { startSessionReducer } = this.props;

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" tag="button" style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="fa fa-calendar-check font-size-17 primary-color" style={{ marginRight: '10px' }} />
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div className="safra-container">
                                <span className='safra-text primary-color'>
                                    {startSessionReducer.configSession == null || startSessionReducer.configSession.safraAtiva == null ?
                                        "Nenhuma Safra Selecionada" : startSessionReducer.configSession.safraAtiva.nome
                                    }
                                </span>
                            </div>
                            {startSessionReducer.configSession != null && startSessionReducer.configSession.fazendaSelecionada != null &&
                                <div className="fazenda-container">
                                    <span className='fazenda-text primary-color'>
                                        {startSessionReducer.configSession.fazendaSelecionada.nome}
                                    </span>
                                </div>
                            }
                        </div>
                        <i className="fa fa-angle-down primary-color" style={{ marginLeft: '5px' }} />
                    </DropdownToggle>

                    <DropdownMenu right>
                        {startSessionReducer.configSession == null || startSessionReducer.configSession.safras == null || startSessionReducer.configSession.safras.length <= 1 ?
                            <React.Fragment /> :
                            <React.Fragment>
                                <DropdownItem >
                                    <div onClick={() => this.setState({
                                        modalSafraOpen: true
                                    })}>

                                        {startSessionReducer.configSession == null || startSessionReducer.configSession.safraAtiva == null || startSessionReducer.configSession.safraAtiva == null ?
                                            <i className="fa fa-check font-size-17 align-middle mr-1"></i> : <i className="fa fa-exchange-alt font-size-17 align-middle mr-1"></i>}
                                        {startSessionReducer.configSession == null || startSessionReducer.configSession.safraAtiva == null || startSessionReducer.configSession.safraAtiva == null ?
                                            "Acessar Safra" : "Trocar de Safra"}
                                    </div>
                                </DropdownItem>
                                <div className="dropdown-divider"></div>
                            </React.Fragment>
                        }
                        <DropdownItem
                            tag="a"
                            href="/safraCadastro"
                            onClick={() => {
                                trackEvent('Clicou na Safra Menu > Gerenciar Safras');
                                this.props.trackingEvent(MODULES_ENUM.AGRIC, MODULE_FUNCTIONALITY_ENUM.SAFRA);
                            }}
                        >
                            <i className="mdi mdi-calendar font-size-17 align-middle mr-1" />Gerenciar Safras
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>

                {/* MODAL ATIVAR SAFRA */}
                <Modal isOpen={this.state.modalSafraOpen} size="xl">
                    <ModalHeader>Acessar Safra</ModalHeader>
                    <ModalBody>
                        <h4 className="font-size-18">Selecione a safra que você deseja acessar:</h4>

                        <TableNoLazy list={startSessionReducer.configSession.safras}>
                            {!this.state.isMobile && (
                                <Column field='status' header='Ativo' body={this.renderColumnAtivo} style={{ textAlign: 'center', width: '100px' }} />
                            )}

                            <Column field='nome' header='Nome' body={this.renderColumnName} />

                            {!this.state.isMobile && (
                                <Column field='dataInicial' header='Data Inicial' body={this.renderColumnDataInicial} style={{ textAlign: 'center', width: '150px' }} />
                            )}

                            {!this.state.isMobile && (
                                <Column field='dataFinal' header='Data Final' body={this.renderColumnDataFinal} style={{ textAlign: 'center', width: '150px' }} />
                            )}

                            <Column style={{ textAlign: 'center', width: this.state.isMobile ? '35%' : '20%' }}
                                body={(rowData, column) => {
                                    return (
                                        <Button color="primary" onClick={() => this.props.selectSafraFazenda(rowData.id)} >
                                            <i className='fa fa-check' /> Acessar Safra
                                        </Button>
                                    );
                                }} />
                        </TableNoLazy>
                    </ModalBody>
                    {/* <ModalFooter>
                        <Button color="light" onClick={() => this.setState({
                            modalSafraOpen: false
                        })} >Fechar</Button>
                    </ModalFooter> */}
                </Modal>
            </React.Fragment>
        );
    }
}

export function mapStateToProps(state) {
    const { startSessionReducer } = state.entities;
    return { startSessionReducer };
};

function mapDispatchToProps(dispatch) {
    return {
        selectSafraFazenda: (id) => dispatch({ type: SELECT_SAFRA_FAZENDA, id }),
        trackingEvent: (module, functionality) => dispatch({ type: CREATE_TRACK_MOD_LOG, module, functionality }),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(SafraMenu));
